var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.30566 9.086L21.3057 9.086","stroke":"white","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15.861 1.88599L23.161 9.08599L15.861 16.386","stroke":"white","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowRight.defaultProps = {"width":"25","height":"18","viewBox":"0 0 25 18","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
